module.exports = __webpack_public_path__ + "img/logo.f570b8cf.png";